import {
  getPaywallPrice,
  getQueryPaywallPriceId,
} from "../helpers/paywallPrices";
import type { CheckoutProps } from "../types/CheckoutProps";

export const useCheckoutPaywallPrice = ({ paywall }: CheckoutProps) =>
  getPaywallPrice(paywall, getQueryPaywallPriceId());
